import jwt_decode from 'jwt-decode';
import { findIdTokenKey } from '../find-id-token/find-id-token';

/** @see https://stackoverflow.com/a/55193363/1722693 */
export default function getUserInfo() {
  const idTokenKey = findIdTokenKey();
  if (!idTokenKey) return;
  const idToken = localStorage.getItem(idTokenKey.toString());
  const {
    email,
    permissions,
    'cognito:username': username,
  } = jwt_decode(idToken);

  return {
    username,
    email,
    permissions: permissions
      ? JSON.parse(permissions)?.['dropshipments'] || []
      : [],
  };
}
